import React from "react";
import "./MustPay.css";

const formatPay = pay => {
  const num = Number.parseFloat(pay).toFixed(2);
  if (isNaN(num)) {
    return `$ 0.00`;
  }
  return "$ " + num;
};
class MustPay extends React.Component {
  render() {
    return (
      <div className="must-pay-wrapper">
        <h3 className="must-pay">{this.props.header}</h3>
        <p className="must-pay-price">{this.props.pay}</p>
      </div>
    );
  }
}

export default MustPay;
export { formatPay };
